import { TimeSlider, TimeSliderInstance, useStore } from '@vidstack/react';
import { useRef } from 'react';

interface SeekBarProps {
  className?: string;
}
export const SeekBar = ({ className }: SeekBarProps) => {
  const ref = useRef<TimeSliderInstance>(null);
  const { pointing } = useStore(TimeSliderInstance, ref);

  return (
    <div className={`h-[4px] flex items-end ${className}`}>
      <TimeSlider.Root
        ref={ref}
        className="relative flex h-[4px] w-full cursor-pointer touch-none select-none items-center group-hover/recording-player:h-[6px] transition-[height] duration-300"
      >
        <TimeSlider.Track className="relative h-full w-full bg-[var(--scarlet-gray-80)]">
          <TimeSlider.TrackFill className="absolute h-full w-[var(--slider-fill)] [background-image:var(--icon-gradient-background-blue)]" />
        </TimeSlider.Track>
        <TimeSlider.Thumb
          className="absolute top-1/2 h-[10px] w-[12px] -translate-y-1/2 rounded-8 bg-white border border-solid border-[var(--blue-40)] opacity-0 group-hover/recording-player:opacity-100 transition-[height,width,opacity] duration-300"
          style={{
            left: 'max(0%, min(calc(var(--slider-fill) - 6px), calc(100% - 12px)))',
          }}
        />
        {pointing && (
          <TimeSlider.Preview className="[--media-slider-preview-offset:4px]">
            <TimeSlider.Value className="rounded-4 bg-black p-02 label-01 text-text-on-color shadow-32" />
          </TimeSlider.Preview>
        )}
      </TimeSlider.Root>
    </div>
  );
};
